import React, { useState, useRef, useEffect } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';
import { es } from 'date-fns/locale';
import { Form } from 'react-bootstrap';
import './DateInputDMY.css';

// yyyy-mm-dd (what the rest of the form/backend expects) <-> local Date object.
const isoToDate = (iso) => {
  if (!iso) return undefined;
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const dateToIso = (date) => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const formatDMY = (date) => {
  if (!date) return '';
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${d}/${m}/${date.getFullYear()}`;
};

// Calendar date picker, always displayed as DD/MM/YYYY regardless of browser
// locale (native <input type="date"> renders per the browser's own locale —
// e.g. MM/DD/YYYY in Chromium — which can't be overridden via a "lang" attribute).
const DateInputDMY = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selected = isoToDate(value);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <Form.Control
        type="text"
        readOnly
        placeholder="DD/MM/AAAA"
        value={formatDMY(selected)}
        onClick={() => setOpen((o) => !o)}
      />
      {open && (
        <div className="date-input-dmy-popover">
          <DayPicker
            mode="single"
            locale={es}
            selected={selected}
            onSelect={(date) => {
              onChange(dateToIso(date));
              setOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DateInputDMY;
